const translations = {
  'fields.name': 'Name',
  'fields.status': 'Status',
  'fields.description': 'Description',
  'fields.fieldValues': 'Additional fields',
  'fields.place': 'Destination',
  'fields.priority': 'Priority',
  'fields.user': 'Responsible',
  'fields.createdBy': 'Responsible',
  'fields.group': 'Group',
  'fields.documents': 'Documents',
  'fields.asset': 'Assets',
  'fields.scheduling': 'Scheduling',
  'fields.events': 'Events',
  'fields.address': 'Address',
  by: 'by',
  anonymous: 'Anonymous',
  yes: 'yes',
  no: 'no',
  operation: 'Operation',
  date: 'Date',
  operationDetails: 'Operation details',
  seeDetails: 'View details',
  'operations.create': 'Creation',
  'operations.update': 'Update',
  'operations.remove': 'Remove',
  'operations.notSupported': 'Not supported'
}

export default translations
